import BaseComponent from '../../js/base-component';
import Gumshoe from 'gumshoejs';

export default class ScrollspyComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
    }

    init(){
        const instance = new Gumshoe('#scrollspy a',{
            offset: 116,
            reflow: false,
            events: true,
            navClass: 'active',
        });
    }
}
